<template>
  <div>
    <div class="menu">
      <div class="logo-box">
        <img src="../assets/logo.png" class="logo" />
        <p>OM TRADERS</p>
      </div>
      <div class="contract-box">Email: <span>hugh@vista-hk.com</span></div>
    </div>
    <div class="menu-box">
      <div class="list">
        <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">
          Home
        </div>
        <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
          About us
        </div>

        <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
          Services
        </div>
        <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">
          Contact
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "about" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "offers" });
          break;
        case 5:
          this.$router.push({ path: "contact" });
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.menu {
  padding: 20px 360px;
  display: flex;
  justify-content: space-between;
  background-color: #101527;
  .logo-box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .logo {
      width: 46px;
      height: 37px;
      margin-right: 14px;
    }
    p {
      font-family: Prompt, Prompt;
      font-weight: 800;
      font-size: 26px;
      color: #ffffff;
    }
  }
  .contract-box {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 18px;
    line-height: 45px;
    color: rgba(255, 255, 255, 0.6);
    span{
      color: #fff;
    }
  }
}

.menu-box {
  display: flex;
  padding: 0 360px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #fff;
  height: 80px;
  position: relative;
  cursor: pointer;
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .select {
      color: #FFFFFF;
    }
    div {
      font-weight: 400;
      font-size: 16px;
      padding: 0 30px;
      color: rgba(255,255,255,0.6);
    }
  }
  .btn {
    width: 112px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffd808;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 16px;
    border-radius: 4px 4px 4px 4px;
    color: #333;
    margin-right: 40px;
  }
}
</style>
